import styled from "@emotion/styled";

import { theme } from "shared/lib/styles";

import { Figure } from "scmp-app/components/content/content-cover-image/styles";
import { ContentItemHomeSecondary } from "scmp-app/components/content/content-item-render/variants/home-secondary";
import { Headline } from "scmp-app/components/content/content-item-render/variants/home-secondary/styles";
import { ContentItemSectionTopLeadPrimary } from "scmp-app/components/content/content-item-render/variants/section-top-lead-primary";
import {
  Headline as LeadHeadline,
  LeadingImage,
} from "scmp-app/components/content/content-item-render/variants/section-top-lead-primary/styles";
import { SectionLink } from "scmp-app/components/content/content-sections/styles";
import {
  HomeSponsorTagContainer,
  HomeSponsorTagWrapper,
} from "scmp-app/components/sponsor-tag/styles";
export const HeroContentsContainer = styled.div`
  ${LeadingImage} {
    ${Figure} {
      aspect-ratio: 3/2;

      ${theme.breakpoints.up("tablet")} {
        aspect-ratio: 250/99;
      }
    }
  }

  ${LeadHeadline} {
    font-size: 18px;
    line-height: 25.2px;
    ${theme.breakpoints.up("tablet")} {
      font-size: 22px;
      line-height: 30.8px;
    }
    ${theme.breakpoints.up("desktop")} {
      font-size: 28px;
      line-height: 39.2px;
    }
  }

  ${SectionLink} {
    color: #001246;
    font-size: 15px;
    line-height: 18px;
  }
`;

export const StyledContentItemSectionTopLeadPrimary = styled(ContentItemSectionTopLeadPrimary)`
  ${theme.breakpoints.up("tablet")} {
    grid:
      "leading-image leading-image" min-content
      "primary rest" min-content
      / 1fr calc((100% - 32px) / 3);
  }

  ${HomeSponsorTagContainer} {
    max-inline-size: 240px;
  }

  ${HomeSponsorTagWrapper} {
    inline-size: 100%;
  }
`;

export const StyledContentItemHomeSecondary = styled(ContentItemHomeSecondary)`
  display: flex;
  flex-direction: column;
`;

export const HeroRest = styled.div`
  ${StyledContentItemHomeSecondary} {
    &:not(:last-child) {
      margin-block-end: 20px;
      padding-block-end: 20px;
      border-block-end: 1px solid rgba(0, 0, 0, 0.1);
    }

    ${Headline} {
      font-size: 15px;
      line-height: 21px;
    }
  }
`;
